import React from 'react';
import { CartProvider } from './CartContext.js';
import { ToastProvider } from './ToastContext.js';
import { LanguageProvider } from './LanguageContext.js';
import { ThemeProvider } from './ThemeContext.js';
import { AuthProvider } from './AuthContext';
import { InstallProvider } from './InstallContext';
import { PublicSettingsProvider } from './PublicSettingsContext.js';
import { StoreProvider } from './StoreContext.js';

export function AppProviders({ children }) {
  return (
    <StoreProvider>
      <InstallProvider>
        <PublicSettingsProvider>
          <ToastProvider>
            <CartProvider>
              <AuthProvider>
                <LanguageProvider>
                  <ThemeProvider>{children}</ThemeProvider>
                </LanguageProvider>
              </AuthProvider>
            </CartProvider>
          </ToastProvider>
        </PublicSettingsProvider>
      </InstallProvider>
    </StoreProvider>
  );
}
